import { render, staticRenderFns } from "./goodsCreate.vue?vue&type=template&id=39ddf052&scoped=true"
import script from "./goodsCreate.vue?vue&type=script&lang=js"
export * from "./goodsCreate.vue?vue&type=script&lang=js"
import style0 from "./goodsCreate.vue?vue&type=style&index=0&id=39ddf052&prod&lang=less&scoped=true"
import style1 from "./goodsCreate.vue?vue&type=style&index=1&id=39ddf052&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddf052",
  null
  
)

export default component.exports